import styled from 'styled-components';

import { NeutralColors } from '@/theme';

export const RemoveOption = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 12px;
  cursor: pointer;
  border: none;
  border-top: 1px solid ${NeutralColors[20]};
  color: ${NeutralColors[90]};
  background: transparent;
  width: 100%;
  text-align: left;
  font-size: inherit;
  font-family: inherit;

  &:hover {
    background-color: ${NeutralColors[10]};
  }

  &:focus-visible {
    outline: 2px solid ${NeutralColors[50]};
    outline-offset: -2px;
  }
`;
